/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_AddInputs */

const en_branches_add = /** @type {(inputs: Branches_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add branch`)
};

const pt_br2_branches_add = /** @type {(inputs: Branches_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar filial`)
};

/**
* | output |
* | --- |
* | "Add branch" |
*
* @param {Branches_AddInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_add = /** @type {((inputs?: Branches_AddInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_AddInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_add(inputs)
	return pt_br2_branches_add(inputs)
});